import { AcquisitionStrategy, ActualDataType, FlatMode, TimeUnit } from '../models/enum';
import { IFrequency } from '../models/IFrequency';
import { VisibleObjectBase } from '../models/entities';
import { WideError } from '../common/';
import { IMeasurable } from './contracts';

export interface TagDefinition extends VisibleObjectBase, IMeasurable {
    acquisitionPointGuid: string;
    acquisitionStrategy: AcquisitionStrategy;
    actualDataType: ActualDataType;
    color: string;
    dataSheet: string;
    defaultValue: number;
    digitalSetGuid: string;
    flatMode: FlatMode;
    importedComment: string;
    importedPointID: number;
    importedPointType: number;
    importedUnit: string;
    isIgnored: boolean;
    isReviewRequired: boolean;
    lag: IFrequency;
    lagSpan?: string;
    max: number;
    min: number;
    pfd: string;
    pid: string;
    resolution: number;
    resolutionPercentage: number;
    sourceUnitGuid: string;
    stdDevThreshold: number;
    validityInterval: number;
    validityUnit: TimeUnit;
    variableSubtypeGuid: string; // left over for old name
}

export interface ITagStatus {
    status: TagStatus;
    errors: WideError[];
}

export enum TagStatus {
    INVALID,
    REQUIRE_REVIEW,
    IGNORED,
    VALID
}

export interface ITagsStatusCount {
    invalid: number;
    requireReview: number;
    ignored: number;
    total: number;
}